export const useClipboardParagraphMatcher = () => {
  return (node: any, delta: any) => {
    const pInsert = delta.ops.find((op: any) => {
      if (op.insert && typeof op.insert != "string") {
        return false;
      }

      return op.insert?.includes("\n");
    });

    const styleObject = useConvertElementStyles(node);

    if (pInsert) {
      // Initialize attributes if they don't exist
      if (!pInsert.attributes) {
        pInsert.attributes = {};
      }

      if (styleObject["line-height"]) {
        var styleLineHeight = styleObject["line-height"];

        if (
          styleLineHeight.includes("px") ||
          styleLineHeight.includes("normal")
        ) {
          switch (styleLineHeight) {
            case "normal":
              pInsert.attributes["lineheight"] = "1";
              break;
            case "44px":
              pInsert.attributes["lineheight"] = "3";
              break;
            case "36.6667px":
              pInsert.attributes["lineheight"] = "2.5";
              break;
            case "29.3333px":
            case "32px":
              pInsert.attributes["lineheight"] = "2";
              break;
            case "22px":
              pInsert.attributes["lineheight"] = "1.5";
              break;
            case "16.8667px":
              pInsert.attributes["lineheight"] = "1.15";
              break;
          }
        } else {
          let styleLineHeightNumber = parseFloat(styleObject["line-height"]);

          // Round the stylelineheight to 2
          let roundedStyleLineHeight = styleLineHeightNumber.toFixed(2);
          const val = parseFloat(roundedStyleLineHeight);

          const targets = [1, 1.15, 1.5, 2];
          const closest = targets.reduce((prev, curr) =>
            Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev
          );

          pInsert.attributes["lineheight"] = closest.toString();
        }
      }

      if (styleObject["text-align"]) {
        pInsert.attributes["align"] = styleObject["text-align"];
      }
    }

    return delta;
  };
};
